<template>
  <div>
    <vue-headful title="Over Derect" />
    <Header page_title="Over Ons" />
    <div class="about-us-banner">
      <svg-icon class="about-us-wave" icon="wave" />
    </div>
    <div class="pb-4">
      <div class="container-fluid">
        <div class="text-14" v-if="cms" v-html="cms.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      cms: null,
      tutorial: false
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
    if (localStorage.getItem("user-token")) {
      $('.tutorial').hide();
      $('.collapse').collapse();
    }
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.cms = await this.getAPIList("cms/about_derect");
    }
  }
};
</script>

<style>
.about-us-banner {
  margin-top: -35px;
  min-height: 300px;
  background: #484848 url(../assets/about.png) 50% no-repeat;
  background-position: 50% 30%;
  background-size: 100%;
  background-size: cover;
  position: relative;
}

.about-us-banner .about-us-wave {
  display: block;
  position: absolute;
  bottom: 0;
  z-index: 1;
  width: 100%;
  color: #FFF;
}
.show_more[aria-expanded="true"] {
  display: none;
}

.custom_intro {
  background: #FFF;
  position: relative;
  margin-bottom: 50px;
  margin-top: 20px;
}

.custom_full_width {
  width: 100% !important;
  max-width: unset !important;
  overflow: hidden;
}

.custom_intro > p:first-child {
  font-size: 30px;
}

.custom_intro > p:not(:first-child) {
  font-size: 14px;
  line-height: 25px;
  color: #64513D;
  font-weight: 200 !important;
  position: relative;
  z-index: 1;
}

.custom_intro > .show_more {
  font-size: 16px;
  font-weight: 400;
  color: #FFCD00;
  position: relative;
  z-index: 1;
  cursor: pointer;
}

.custom_options {
  list-style: none;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
}

.custom_options > li {
  background-color: #F6F6F6;
  border-radius: 10px;
  padding: 15px 30px;
  text-align: center;
}

.custom_options > li:not(:first-child) {
  margin-left: 15px;
}
.custom_options > li strong {
  font-size: 16px;
  line-height: 30px;
}
.custom_options > li strong > a:first-child {
  margin-top: 10px;
}

.custom_options > li strong > a:last-child {
  background-color: #FFF;
}

.custom_options > li strong > a {
  font: 16px/50px "Real Head Pro";
  font-weight: normal;
  display: block;
  text-align: center;
  background-color: #FFCD00;
  color: #625a55;
  border-radius: 10px;
  margin-bottom: 15px;
}
.custom_other_details {
}
.custom_other_details p {
  color: #64513D;
}

.custom_other_details a {
  color: #FFCD00;
}

@media (max-width: 768px) {
  .custom_options {
    display: block;
  }
  .custom_options > li:not(:first-child) {
    margin-left: 0;
    margin-top: 50px !important;
  }
  .about-us-banner {
    min-height: 200px;
  }
  .about-us-banner img {
    max-width: 125px;
  }
}

@media (max-width: 500px) {
  .custom_options > li {
    padding: 15px;
  }
}
</style>
